/**
 * M-196: phiếu nhập kho hàng bán có dòng tính theo kg — bấm "In phiếu" thì hỏi
 * số bao của từng dòng kg rồi mới in.
 *
 * Câu hỏi cần trả lời: người in có thật sự nhập số bao rồi in không, hay
 * thường bấm Huỷ (hộp thoại thừa / làm chậm việc in); mỗi lần in có bao nhiêu
 * dòng kg. Số bao chỉ in ra giấy, không lưu nên DB không trả lời được.
 *
 * Chỉ gửi đếm dòng và giai đoạn: không mã phiếu, không số bao, không số kg.
 * Contract ở `docs/analytics/stock-in-note-print-bags.md`.
 */
import { getAnalyticsActor, posthog } from './posthog'

const stages = ['prompted', 'printed', 'cancelled'] as const

/** `prompted`: hộp thoại số bao mở ra. `printed`: nhập xong và gửi lệnh in.
 *  `cancelled`: đóng hộp thoại không in. */
export type StockInNoteBagsStage = (typeof stages)[number]

export interface StockInNoteBagsEvent {
    stage: StockInNoteBagsStage
    /** Số dòng tính theo kg (số ô số bao). */
    kgRowCount: number
    /** Tổng số dòng của phiếu. */
    rowCount: number
    /** Chỉ khi `printed`: số dòng kg có nhập số bao (còn lại để trống). */
    filledRowCount?: number
}

/** Analytics hỏng tuyệt đối không được chặn việc in phiếu. */
export function captureStockInNoteBags(event: StockInNoteBagsEvent) {
    try {
        const actor = getAnalyticsActor()
        if (!actor) return
        if (!stages.includes(event.stage)) return
        posthog.capture('stock_in_note_bags', {
            schema_version: 1,
            warehouse: 'sales',
            stage: event.stage,
            kg_row_count: event.kgRowCount,
            row_count: event.rowCount,
            ...(event.stage === 'printed' && event.filledRowCount !== undefined
                ? { filled_row_count: event.filledRowCount }
                : {}),
            ...actor,
        })
    } catch {
        // Analytics failure must not block printing.
    }
}
